import { useEffect, useState, Fragment } from "react";
import { connect } from "react-redux";
import {
	Button,
	Card,
	Col,
	Form,
	Input,
	List,
	PageHeader,
	Row,
	Select,
	Spin,
} from "antd";

import { CheckPermission } from "scripts/helpers";
import { setRoute } from "scripts/reducer";
import { Permissions } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import TextEditor from "components/TextEditor";

const Component = ({ onSetRoute, parentName, permissions, routeName }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { address, loaded, data, submitting } = state;
	const [form] = Form.useForm();

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				if (values.address) {
					values.address = values.address.replaceAll(/<\/p><p>/g, "<br />");
					values.address = values.address.replaceAll("<br>", "");
					values.address = values.address.replaceAll(
						/<\/p><p\s+class="[^"]*">/g,
						"<br />"
					);
				}

				API.contact.update(values).finally(() => {
					setState((prevState) => ({ ...prevState, submitting: false }));
				});
			});
		}
	};

	const componentDidMount = () => {
		onSetRoute({ openKey: parentName, selectedKey: routeName });

		API.contact
			.details()
			.then(({ data }) => {
				if (permissions.update) {
					setState((prevState) => ({ ...prevState, loaded: true }));

					form.setFieldsValue(data);
				} else {
					setState((prevState) => ({ ...prevState, ...data, loaded: true }));
				}
			})
			.catch(() => {
				setState((prevState) => ({ ...prevState, loaded: true }));
			});
	};

	useEffect(componentDidMount, []);

	return (
		<>
			<PageHeader title={Resources.contactUs} />
			<Row className="sp-content-center">
				<Col xs={24} md={18} xl={16} xxl={14}>
					<Card>
						{loaded ? (
							permissions.update ? (
								<Form layout="vertical" form={form}>
									<>
										<Form.Item
											name="address"
											label={Resources.address}
											rules={Rules.required}
										>
											<TextEditor />
										</Form.Item>
										<Row gutter={[16, 8]}>
											<Form.List name="data">
												{(fields, { add, remove }) => (
													<>
														{fields.map(({ key, name, ...restField }) => (
															<Fragment key={key}>
																<Col xs={14}>
																	<Form.Item
																		name={[name, "value"]}
																		label={Resources.value}
																		rules={Rules.required}
																		{...restField}
																	>
																		<Input className="sp-input-ltr" />
																	</Form.Item>
																</Col>
																<Col xs={8}>
																	<Form.Item
																		name={[name, "key"]}
																		label={Resources.type}
																		rules={Rules.required}
																		{...restField}
																	>
																		<Select
																			options={[
																				{
																					value: "mobile",
																					label: Resources.mobile,
																				},
																				{
																					value: "phone",
																					label: Resources.phone,
																				},
																				{
																					value: "eitaa",
																					label: Resources.eitaa,
																				},
																				{
																					value: "soroush",
																					label: Resources.soroush,
																				},
																				{
																					value: "igap",
																					label: Resources.igap,
																				},
																				{
																					value: "fax",
																					label: Resources.fax,
																				},
																				{
																					value: "instagram",
																					label: Resources.instagram,
																				},
																				{
																					value: "telegram",
																					label: Resources.telegram,
																				},
																				{
																					value: "whatsapp",
																					label: Resources.whatsapp,
																				},
																				{
																					value: "website",
																					label: Resources.website,
																				},
																				{
																					value: "email",
																					label: Resources.email,
																				},
																			]}
																		/>
																	</Form.Item>
																</Col>
																<Col xs={2}>
																	<Button
																		type="link"
																		onClick={() => remove(name)}
																		style={{
																			marginTop: 32,
																			padding: 0,
																		}}
																		block
																	>
																		<i className="fa fa-minus-circle" />
																	</Button>
																</Col>
															</Fragment>
														))}
														<Col xs={24}>
															<Form.Item>
																<Button
																	type="dashed"
																	onClick={() => add()}
																	block
																>
																	{Resources.add}
																</Button>
															</Form.Item>
														</Col>
													</>
												)}
											</Form.List>
										</Row>
										<Button
											type="primary"
											onClick={handleSubmit}
											loading={submitting}
											style={{ float: "left", marginTop: 16 }}
										>
											{Resources.confirm}
										</Button>
									</>
								</Form>
							) : (
								<List>
									<List.Item>
										<List.Item.Meta
											title={Resources.address}
											description={
												<div
													dangerouslySetInnerHTML={{
														__html: address?.replace(/\n/g, "<br />"),
													}}
												></div>
											}
										></List.Item.Meta>
									</List.Item>
									{data?.map(({ key, value }, i) => (
										<List.Item key={i}>
											<List.Item.Meta
												title={Resources[key]}
												description={value}
											></List.Item.Meta>
										</List.Item>
									))}
								</List>
							)
						) : (
							<Spin className="sp-block-spin" />
						)}
					</Card>
				</Col>
			</Row>
		</>
	);
};

export default connect(
	(state) => {
		return {
			permissions: {
				update: CheckPermission(
					state.user.permissions,
					Permissions.CONTACT_UPDATE
				),
			},
		};
	},
	(dispatch) => {
		return {
			onSetRoute: (data) => dispatch(setRoute(data)),
		};
	}
)(Component);
